import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AccountTransferIDs, SupportState } from './support.state';
import { StudentTableRows } from '../models/student-table-rows.model';

const selector = <T>(mapping: (state: SupportState) => T) =>
  createSelector(selectDashboardFeature, mapping);

export const selectDashboardFeature =
  createFeatureSelector<SupportState>('support');

export const getSupportState = selector(
  (state: SupportState): SupportState => state,
);

export const getStudentRows = selector(
  (state: SupportState): StudentTableRows[] =>
    state.studentTransfer.studentTableRows,
);
export const getCachedStudentRows = selector(
  (state: SupportState): StudentTableRows[] =>
    state.studentTransfer.cacheStudentTableRows,
);

export const getTransferinatorAccountIds = selector(
  (state: SupportState): AccountTransferIDs => state.studentTransfer.accountIds,
);

export const getStudentTransferError = selector(
  (state: SupportState) => state.studentTransfer.error,
);

export const getCleverSupport = selector(
  (state: SupportState) => state.cleverSupport,
);

export const getCleverCurrentAccountId = selector(
  (state: SupportState): number => state.cleverSupport.accountId,
);

export const getCleverCurrentAccountLookupMethod = selector(
  (state: SupportState): string => state.cleverSupport.result.lookupMethod,
);

export const getUnDeleterSupport = selector(
  (state: SupportState) => state.undeleteSupport,
);
